import { LEARN } from 'constants/actionTypes';

const initialState = {
  apiKey: null,
  appId: null,
  indexes: [],
  sourcePage: null,
  loading: true,
  query: '',
  filters: {
    topic: {
      id: '',
    },
    progress: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LEARN.SEARCH.READY:
      return {
        ...state,
        ...action.search,
        loading: false,
      };

    case LEARN.SEARCH.SET_SOURCE_PAGE:
      return {
        ...state,
        sourcePage: action.sourcePage,
      };

    case LEARN.SEARCH.RESET_SOURCE_PAGE:
      return {
        ...state,
        sourcePage: null,
      };

    case LEARN.SEARCH.UPDATE_QUERY:
      return {
        ...state,
        query: action.query,
      };

    case LEARN.SEARCH.UPDATE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]: action.value,
        },
      };

    case LEARN.SEARCH.RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };

    default:
      return state;
  }
};
